import React from "react";
import './i18n';
import ReactDOM from "react-dom";
import "react-toastify/dist/ReactToastify.css";
// import "./index.css";
import App from "./App";
import { Provider } from "react-redux";
import store from "./store/store";
import PBFMap from "./components/map/map+Pbf";
import { MapWfs } from "./components/map/map_landmarks_wfs";
import { Route, Router } from "@mui/icons-material";
import { Map } from "./components/map";
ReactDOM.render(
  <Provider store={store}>
    <App />
    {/* <MapWfs /> */}
    {/* <Map /> */}
   
  </Provider>,
  document.getElementById("root")
);
